module.exports = __webpack_public_path__ + "pc/img/img_marketing_main.d138948f.png";